// src/utils/metaPixel.js
export const initMetaPixel = () => {
    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = "https://connect.facebook.net/en_US/fbevents.js";
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, "script");

    // eslint-disable-next-line no-undef
    fbq("init", "1150216927114920"); // Replace with your Pixel ID
    // eslint-disable-next-line no-undef
    fbq("track", "PageView");
};

export const getUTMParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        source: urlParams.get("utm_source") || "organic",
        medium: urlParams.get("utm_medium") || "organic",
        campaign: urlParams.get("utm_campaign") || "none",
    };
};

export const trackMetaEvent = (event, data = {}) => {
    const utmData = getUTMParams();
    if (window.fbq) {
        window.fbq("track", event, { ...data, ...utmData });
    }
};
export const trackMetaCustomEvent = (event, data = {}) => {
    const utmData = getUTMParams();
    if (window.fbq) {
        window.fbq("trackCustom", event, { ...data, ...utmData });
    }
};